var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("span", { staticClass: "licence-number LicenceRenderer d-flex" }, [
    _vm._m(0),
    _vm._v(" "),
    _c("span", { staticClass: "licence-text" }, [
      _vm._v(_vm._s(this.licenceNumber)),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("span", { staticClass: "licence-symbol" }, [
      _c("i", { staticClass: "fa fa-hashtag" }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }